import { apiPostRequest } from './apiClient';
import * as Sentry from '@sentry/react';
import { logout } from './logout';
import i18n from '@/i18n';

/**
 * アカウント削除処理
 */
export async function accountDelete(userId: number): Promise<void> {
    try {
        // 登録情報削除APIを呼び出し
        const response = await apiPostRequest('/api/user/deactivate', userId);
        if (response?.ok) {
            // ログアウト
            await logout();
            return;
        }

        // Sentryにレスポンスエラーを送信
        Sentry.captureMessage(i18n.t('settings:accountDelete.error'), {
            level: 'error',
            tags: {
                action: 'account_delete',
                status: response?.status,
            },
            extra: {
                userId: userId,
                responseStatus: response?.status,
                responseStatusText: response?.statusText,
            },
        });
        // ログインページにリダイレクト
        window.location.href = '/login';
        return;
    } catch (error) {
        // Sentryにエラーを送信
        Sentry.captureException(error, {
            tags: {
                action: 'account_delete',
            },
            extra: {
                userId: userId,
            },
        });
        // ログインページにリダイレクト
        window.location.href = '/login';
        return;
    }
}
